import { Component} from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { PagesServices } from '../../../pages.services';

@Component({
    selector: 'preview-navigation-right',
    templateUrl: './preview-navigation-right.html',
    styleUrls: ['./preview-navigation-right.scss']
})
export class PreviewNavigationRight {

    constructor(
        private _route: ActivatedRoute,
        private _pagesService: PagesServices) {
       
    }

    disabled: boolean =  false;
    datas:any;
    position:number = -1;
    folderId:any = "";
    bookmarkId:any = null;
    preload:boolean = true;

    ngOnInit(){
        this.datas = this._pagesService.GetNavigationPreviewData();
        let ids = this.datas .map(d => d.id);
        this._route.queryParams.subscribe(params => {
            let id = params['Id'];
            
            if(params['folderId'] != undefined){
                this.folderId = "&folderId="+params['folderId'];
            }
            this.position = ids.indexOf(id);

            if(this.position >= this.datas.length-1)
            this.disabled = true;
            else this.disabled = false;
        });

        setTimeout(() => {
            this.preload = false;
        }, 2000);
    }

    
    NavigatetoNextPage(){
        if(!this.disabled){
            var nextPage = this.datas[this.position+1];
            history.back();
            let module = 'my-files';
            if(window.location.href.indexOf('all-files') > 0){
                module = 'all-files';
            }
            else if(window.location.href.indexOf('my-folder-files') > 0){
                module = 'my-folder-files';
            }
            else if(window.location.href.indexOf('recycle-bin') > 0){
                module = 'recycle-bin';
            }
            setTimeout(() => {
                switch (nextPage.fileType.toLowerCase()) {
                    case "audio":
                        window.location.href = window.location.origin + '#/pages/'+module+'/audio-preview?Id=' + nextPage.id + this.folderId;
                        break;
                    case "video":
                        window.location.href = window.location.origin + '#/pages/'+module+'/video-preview?Id=' + nextPage.id + this.folderId;
                        break;
                    case "photo":
                        window.location.href = window.location.origin + '#/pages/'+module+'/photo-preview?Id=' + nextPage.id + this.folderId;
                        break;
                    case "document":
                        window.location.href = window.location.origin + '#/pages/'+module+'/document-preview?Id=' + nextPage.id + this.folderId;
                        break;
                }
            },50);
        }
    }
}